export default __webpack_public_path__ + "static/digital_print1-a356be60b612128d968bac185c93a82c.jpg";